/* Gemeinsames Bild-Karussell (cs-mrc) fuer Multirow (Produktseiten) und
   CS Einsatzorte (Startseite): Scroll-Snap-Track (natives Wischen auf
   Touch, Trackpad-Scroll auf Desktop) + optionales Autoplay wie beim
   CS-Hero. Autoplay pausiert bei Hover/Touch, ausserhalb des Viewports,
   in inaktiven Tabs und komplett bei prefers-reduced-motion. Der aktive
   Dot fuellt sich waehrend des Intervalls (CSS-Animation, Neustart per
   --playing-Klasse). Re-Init nach Editor-Reload via shopify:section:load. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initCarousel = (root) => {
    root.setAttribute('data-cs-init', '');
    const track = root.querySelector('[data-cs-track]');
    const slides = [...track.children];
    const dots = [...root.querySelectorAll('[data-cs-dot]')];
    const interval = parseInt(root.dataset.interval, 10) || 5000;
    const autoplay = root.dataset.autoplay === 'true' && !reduced && slides.length > 1;
    let idx = 0;
    let held = false;
    let visible = false;
    let timer = null;

    root.style.setProperty('--cs-mrc-interval', interval + 'ms');

    const running = () => autoplay && visible && !held && !document.hidden;

    const render = () => {
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      root.classList.remove('cs-mrc--playing');
      if (running()) {
        void root.offsetWidth; /* Reflow erzwingt Neustart der Fuell-Animation */
        root.classList.add('cs-mrc--playing');
      }
    };

    const schedule = () => {
      clearTimeout(timer);
      if (running()) timer = setTimeout(() => goTo(idx + 1), interval);
    };

    const goTo = (i, smooth = true) => {
      idx = (i + slides.length) % slides.length;
      track.scrollTo({ left: idx * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      render();
      schedule();
    };

    /* Wischen/Scrollen des Users erkennen und Dots nachziehen */
    let scrollTimer;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== idx && i >= 0 && i < slides.length) {
          idx = i;
          render();
          schedule();
        }
      }, 80);
    }, { passive: true });

    dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));
    root.querySelector('[data-cs-prev]').addEventListener('click', () => goTo(idx - 1));
    root.querySelector('[data-cs-next]').addEventListener('click', () => goTo(idx + 1));

    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(idx - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(idx + 1); }
    });

    root.addEventListener('mouseenter', () => { held = true; render(); schedule(); });
    root.addEventListener('mouseleave', () => { held = false; render(); schedule(); });
    track.addEventListener('touchstart', () => { held = true; render(); schedule(); }, { passive: true });
    track.addEventListener('touchend', () => { held = false; render(); schedule(); }, { passive: true });
    document.addEventListener('visibilitychange', () => { render(); schedule(); });

    new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      render();
      schedule();
    }, { threshold: 0.35 }).observe(root);

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => goTo(idx, false), 150);
    });
  };

  const initAll = (scope) => {
    scope.querySelectorAll('[data-cs-carousel]:not([data-cs-init])').forEach(initCarousel);
  };

  if (document.readyState !== 'loading') {
    initAll(document);
  } else {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  }
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
